<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="multisteps-form mb-9">
          <div class="row">
            <div class="col-12 col-lg-8 mx-auto my-5"></div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-8 m-auto">
              <div class="card">
                <div
                  class="card-header p-0 position-relative mt-n4 mx-3 z-index-2"
                >
                  <div
                    class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3"
                  >
                    <div class="multisteps-form__progress">
                      <button
                        class="multisteps-form__progress-btn"
                        type="button"
                        title="Editar Rol"
                        :class="activeStep >= 0 ? activeClass : ''"
                      >
                        <span>Editar Rol</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <form class="multisteps-form__form">
                    <!--single form panel-->
                    <h5 class="font-weight-bolder mb-0">Información del Rol</h5>
                    <div class="multisteps-form__content">
                      <div class="row mt-3">
                        <div class="col-12 col-sm-6">
                          <label class="form-label col-sm-12">
                            <input
                                id="name"
                                v-model="item.name"
                                placeholder=" "
                                type="text"
                                class="form-control border-bottom"
                                name="name"
                                required
                                :minlength="minLen"
                                :maxlength="maxLen"
                                @input="checkLength('name', maxLen); checkMinLength('name', minLen)"
                            />
                            <span>Nombre *</span>
                          </label>
                        </div>
                      </div>
                      <div v-if="error !== ''">
                        <label
                            type="error"
                            :value="alert"
                            class="alert-warning text-bold"
                        >
                          {{ error }}
                        </label>
                      </div>
                      <div class="row" v-if="ok != null">
                        <material-alert
                            border="top"
                            close-icon="$cancel"
                            :color="colorAlert()"
                            transition="scale-transition"
                            :value="ok"
                            dismissible
                        >
                          {{ textAlert() }}
                        </material-alert>
                      </div>
                      <div class="button-row d-flex mt-4">
                        <material-button
                            type="button"
                            color="danger"
                            variant="danger"
                            class="js-btn-send"
                            @click="getRolesList()"
                        >Cancelar</material-button
                        >
                        <material-button
                            type="button"
                            color="success"
                            variant="gradient"
                            class="ms-auto js-btn-send"
                            :disabled="!isFormValid || error !== ''"
                            @click="editRol()"
                        >Aceptar</material-button
                        >
                      </div>
                    </div>

                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialAlert from "@/components/MaterialAlert.vue";


export default {
  name: "EditRole",
  components: {
    MaterialAlert,
    MaterialButton,
  },
  data() {
    return {
      maxLen: 30,
      minLen: 2,
      ok: null,
      showMenu: false,
      showChangePass: false,
      changePassword: null,
      activeClass: "js-active position-relative",
      activeStep: 0,
      formSteps: 3,
      error: '',
      alert: false,
      idItem: -1,
      item: {
        name: '',
      }
    };
  },
  computed: {
    isFormValid() {
      return Object.values(this.item).every(field => field !== '') && !this.showError;
    },
    getRole() {
      if (this.idItem > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.item = this.$store.getters.getRole;
        return this.item;
      }
      return null
    },
  },
  watch :{
    "$store.state.role": function(role) {
      this.item = role;
      console.log("Role: ", this.item)
    },
    '$store.state.ok': function (value) {
      console.log("state.ok: ", value)
      if (value){
          this.ok = true;
          setTimeout(this.getRolesList, 100);
      }
    },
    '$store.state.errorMessage': function (message) {
      this.error = message;
      this.alert = true;
    }
  },
  methods: {
    checkMinLength(field, minLen) {
      if (field === 'phone' && (this.item[field].toString()).length < minLen ){
        this.error = `El campo debe tener más de ${minLen ? minLen: this.minLen} caracteres`;
        this.showError = true;
        setTimeout(() => {
          this.showError = false;
          this.error = '';
        }, 5000);
      } else if (this.item[field].length < (minLen ? minLen: this.minLen)) {
        this.error = `El campo debe tener más de ${minLen ? minLen: this.minLen} caracteres`;
        this.showError = true;
      }
    },
    checkLength(field, maxLen) {
      if (this.item[field].length >= (maxLen ? maxLen: this.maxLen)) {
        this.showError = true;
        this.error = `El campo no puede tener más de ${maxLen ? maxLen: this.maxLen} caracteres`;
        console.log("error: ", field);
        console.log("error: ", this.error);
        console.log("error: ", this.showError);
      } else {
        this.showError = false;
        this.error = '';
      }
    },
    textAlert() {
      return this.ok
          ? "Rol modificado satisfactoriamiente"
          : "Error al intentar modificar el Rol";
    },
    colorAlert() {
      return this.ok ? "success" : "danger";
    },
    getRolesList(){
      this.$router.push({ path: "/roles/roles-list" });
    },
    editRol() {
      this.$store.dispatch('actionsEditRole', {
        axios: this.$axios,
        id: this.item.id,
        name: this.item.name,
      });
    },
  },
  created() {
    this.idItem = this.$route.params.id !== undefined ? this.$route.params.id : -1;
    this.$store.dispatch('actionsGetRole', {
      'axios': this.$axios,
      'id': this.idItem
    })
  }
};
</script>
<style>
.form-label {
  position: relative;
  display: inline-block;
}


.form-label span {
  position: absolute;
  left: 5px;
  top: 0;
  transition: 0.2s;
  pointer-events: none;
}

.form-label input:focus + span,
.form-label input:not(:placeholder-shown) + span {
  transform: translateY(-25px);
  font-size: 0.8em;
}
</style>
